import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store/store";
import VueYoutubeEmbed from "vue-youtube-embed";
import firebase from "firebase/app";
import vuetify from "./plugins/vuetify";
import "firebase/auth";
import "firebase/firestore";
import "./firebase";
import Chart from "chart.js";
import * as ChartAnnotation from "chartjs-plugin-annotation";
import { ACCOUNT_TYPES } from "./store/UserStore";
import { updateStudentScoring } from "./service/DashboardBackend";

// Vue.config.productionTip = (process.env
// .VUE_APP_PRODUCTION_MODE as unknown) as boolean;
Vue.config.productionTip = process.env.VUE_APP_PRODUCTION_MODE === "true";

// Add plugin to chartjs,
let namedChartAnnotation = ChartAnnotation;
namedChartAnnotation["id"] = "annotation";
Chart.pluginService.register(namedChartAnnotation);

// Wait to load up until the authentication state has been assured
firebase.auth().onAuthStateChanged(user => {
  if (user != null) {
    // Load up Balli, Bala questions from database
    store.dispatch("loadBalliQuestions");
    store.dispatch("loadBalaPassages");
    store.dispatch("loadBalaUnderstanding");
    store.dispatch("loadBalaQuestions");
    store.dispatch("loadBalaWritingTask");

    // load current bala/balli timepoints
    store
      .dispatch("fetchUser", user)
      .then(() => {
        return store.dispatch("loadLatestTimepoints");
      })
      .then(() => {
        if (
          store.getters.balaTimepoint === null ||
          store.getters.balliTimepoint === null
        ) {
          alert("Error: undefined bala/balli timepoint");
          return;
        }
        store.dispatch("loadRadioHeaders");
        // Load up user answers for Balli, Bala, TTMJ
        store.dispatch("loadBalliUserProgress", user.uid);
        store.dispatch("loadTTMJUserProgress", user.uid);
        store.dispatch("loadBalaUserProgress", user.uid);

        // Load dashboard descriptions
        store.dispatch("loadDashboardDescriptions");

        // Load up dashboard data for bala/balli
        let isTeacher = store.getters.user.accountType == ACCOUNT_TYPES.TEACHER;
        let dashboard = isTeacher
          ? "loadTeacherBalaData"
          : "loadStudentBalaData";

        store.dispatch(dashboard, {
          uid: user.uid,
          timepoint: store.getters.balaTimepoint,
          teacherId: store.getters.user.data.teacherId
        });

        if (isTeacher) store.dispatch("loadStudentData", user.uid);
      });
  }
  loadApp();
});
//
// Vue.use(VueYoutubeEmbed);

const loadApp = () => {
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount("#app");
};
